import api from './api';

export interface PlanType {
    id: number;
    value: string;
    label: string;
    name: string;
    price: number;
    billing_cycle: string;
    monthly_price: number;
    yearly_price: number;
    description: string;
}

export interface SubscriptionRequest {
    plan_id: number;
    billing_type: 'monthly' | 'yearly' | 'weekly';
    payment_method: string;
    user: number; // ID del usuario
    end_date: string; // Fecha en formato ISO
}

export const getPlans = async (): Promise<PlanType[]> => {
    try {
        const response = await api.get('/api/plans/');
        return response.data;
    } catch (error) {
        console.error('Error al obtener los planes:', error);
        throw new Error('Error al obtener los planes');
    }
};

export const subscribeToPlan = async (subscriptionData: SubscriptionRequest) => {
    try {
        const response = await api.post('/api/subscriptions/', subscriptionData);
        return response.data;
    } catch (error) {
        console.error('Error al procesar la suscripción:', error);
        throw error;
    }
};

export const getCurrentUser = async () => {
    try {
        const response = await api.get('/api/get_user/');
        return response.data;
    } catch (error) {
        console.error('Error al obtener el usuario actual:', error);
        throw error;
    }
};

export const getSubscribeCurrentPlan = async () => {
    try {
        const response = await api.get('/api/subscriptions/');
        if (response.data && response.data.length > 0) {
            const activeSubscription = response.data.find((sub: any) => sub.is_active === true);
            return activeSubscription || null;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al procesar la suscripción:', error);
        throw error;
    }
};

export interface CreateRecurringPaymentResponse {
    init_point: string;
}

export const createRecurringPayment = async (planId: number): Promise<CreateRecurringPaymentResponse> => {
    try {
        const response = await api.post('/api/payments/create-recurring-payment/', { plan_id: planId });
        return response.data;
    } catch (error) {
        console.error('Error al crear la preaprobación de pago recurrente:', error);
        throw error;
    }
};

export interface CreateOneTimePaymentResponse {
    init_point: string;
}

export const createOneTimePayment = async (planId: number): Promise<CreateOneTimePaymentResponse> => {
    try {
        const response = await api.post('/api/payments/create-one-time-payment/', { plan_id: planId });
        return response.data;
    } catch (error) {
        console.error('Error al crear la preferencia de pago único:', error);
        throw error;
    }
};

export interface CancelSubscriptionRequest {
    subscription_id: string;
}

export interface CancelSubscriptionResponse {
    status: string;
    message: string;
}

export const cancelSubscription = async (subscriptionId: string): Promise<CancelSubscriptionResponse> => {
    try {
        const response = await api.post('/api/payments/cancel_subscription/', { subscription_id: subscriptionId });
        return response.data;
    } catch (error) {
        console.error('Error al cancelar la suscripción:', error);
        throw error;
    }
};